import ptBR from './ptBR'
import enUS from './enUS'

/**/
export default {
  'pt-BR': ptBR,
  'en-US': enUS
}
